import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";

const LinkedInIcon = () => (
  <svg
    className="w-5 h-5"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
  </svg>
);

export default function Header() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationLinks = [
    { path: "/", text: "Home" },
    { path: "/projects", text: "Projects" },
    // { path: "/#insights", text: "Insights" },
    // { path: "/#about", text: "About Us" },
    { path: "mailto:studentpdc@mytnstate.onmicrosoft.com", text: "Contact" },
  ];

  const isActive = path => {
    return location.pathname === path;
  };

  const handleHashLinkClick = (e, path) => {
    if (path.startsWith("/#")) {
      e.preventDefault();
      const sectionId = path.substring(2);
      const element = document.getElementById(sectionId);

      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
    // Close mobile menu when link is clicked
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="bg-white fixed w-full top-0 z-[1000] shadow-sm border-b border-gray-100 backdrop-blur-sm bg-white/95">
      <div className="container mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            {/* <div className="text-2xl font-bold mr-10 text-blue-600">Impact.</div> */}
            <img
              src={logo}
              alt="logo"
              className="w-20 mr-4 rounded-md"
            />
            <div className="hidden md:flex space-x-1">
              {navigationLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.path}
                  className={`nav-link ${isActive(link.path) ? "active" : ""}`}
                  onClick={e => handleHashLinkClick(e, link.path)}
                >
                  {link.text}
                </Link>
              ))}
            </div>
          </div>
          <div className="hidden md:block">
            <a
              href="https://www.linkedin.com/company/info-impact"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary inline-flex items-center gap-2"
            >
              <LinkedInIcon />
              Connect
            </a>
          </div>
          <button
            className="md:hidden focus:outline-none p-2 rounded-md hover:bg-gray-100 transition-colors"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <svg
              className={`w-6 h-6 transform transition-transform duration-200 ${
                isMobileMenuOpen ? "rotate-90" : ""
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-white border-t border-gray-100 transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0 overflow-hidden"
        }`}
      >
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col space-y-3">
            {navigationLinks.map((link, index) => (
              <Link
                key={index}
                to={link.path}
                className={`block py-3 px-4 rounded-md hover:bg-gray-50 transition-colors ${
                  isActive(link.path) ? "bg-blue-50 text-[#0258DA] font-medium" : "text-[#465362]"
                }`}
                onClick={e => handleHashLinkClick(e, link.path)}
              >
                {link.text}
              </Link>
            ))}
            <div className="pt-3 border-t border-gray-100">
              <a
                href="https://www.linkedin.com/company/info-impact"
                target="_blank"
                rel="noopener noreferrer"
                className="block py-3 px-4 bg-[#0258DA] text-white text-center rounded-md hover:bg-blue-700 transition-colors inline-flex items-center justify-center gap-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <LinkedInIcon />
                Connect
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
